import axiosInstance from "./axiosInstance";

const hospitalStructureService = {
    create: async (payload) => {
        try {
            const response = await axiosInstance.post('/hospital-structure/create', payload);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

    getTotal: async () => {
        try {
            const response = await axiosInstance.get('/hospital-structure/total');
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

    getAll: async () => {
        try {
            const response = await axiosInstance.get('/hospital-structure/all');
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

    getByID: async (id) => {
        try {
            const response = await axiosInstance.get(`/hospital-structure/${id}`);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

    update: async (payload) => {
        try {
            const response = await axiosInstance.put('/hospital-structure/update', payload);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

    delete: async (id) => {
        try {
            const response = await axiosInstance.delete(`/hospital-structure/delete/${id}`);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },
};

export default hospitalStructureService;